import React, { useState } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Box,
  Modal,
  MenuItem,
  Select,
  AppBar,
  Toolbar,
  Paper,
  TextField,
  Typography,
  Tooltip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddState = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [countryId, setCountryId] = useState('');
  const [state, setState] = useState('');
  const navigate = useNavigate();

  // Static country data
  const countryData = [
    { countryId: 1, countryName: 'United States' },
    { countryId: 2, countryName: 'Canada' },
    { countryId: 3, countryName: 'United Kingdom' },
    { countryId: 4, countryName: 'Australia' },
    { countryId: 5, countryName: 'Germany' },
  ];

  const handleSave = (e) => {
    e.preventDefault();
    // Simulate API call with timeout
    setTimeout(() => {
      console.log('State saved:', { stateName: state, countryId });
      setCountryId('');
      setState('');
      setShowSuccessModal(true);
    }, 500);
  };

  const handleCancel = () => {
    setCountryId("");
    setState("");
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <Box
          sx={{
            backgroundColor: 'rgba(2, 78, 101, 1)', // dark navy blue
            padding: '12px 16px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            margin: '2px auto',
           width: "100%",
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
        Add State
      </Typography> </Box>

       <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="country">Country:</InputLabel>
            <Select
              id="country"
              autoFocus
              value={countryId}
              label="Country"
              onChange={(e) => setCountryId(e.target.value)}
            >
              {countryData.map((countryItem) => (
                <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                  {countryItem.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            id="state"
            label="State"
            variant="outlined"
            value={state}
            onChange={(e) => setState(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!countryId ? "Select Country" : !state ? "Enter State Name" : ""} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!state || !countryId}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              State Added ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              State Added Successfully
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddState;